import { render, staticRenderFns } from "./MainSupportCard.vue?vue&type=template&id=a2d87f94&scoped=true"
import script from "./MainSupportCard.vue?vue&type=script&lang=js"
export * from "./MainSupportCard.vue?vue&type=script&lang=js"
import style0 from "./MainSupportCard.vue?vue&type=style&index=0&id=a2d87f94&prod&scoped=true&lang=css"
import style1 from "./MainSupportCard.vue?vue&type=style&index=1&id=a2d87f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d87f94",
  null
  
)

export default component.exports